import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, provideZonelessChangeDetection, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { tokenInterceptor } from './core/auth/interceptors/token.interceptor';
import { AuthService } from './core/auth/services/auth.service';
import { environment } from '../environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor]), withFetch()),
    provideCharts(withDefaultRegisterables()),
    provideAppInitializer(async () => {
      const authService = inject(AuthService);
      await authService.setConfig(environment.auth);
    }),
  ]
};

